export function convertObjectIntoString(obj: Object) {
  return Object.keys(obj)
    .map((key) => `${key}=${obj[key as keyof typeof obj]}`)
    .join('&');
}
